import { useDispatch, useSelector } from 'react-redux';
import PendingReservationContainer from './PendingReservationContainer';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import PendingCard from '../PendingsCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPendingReservations } from '@/store/slices/components/dashboard/service';
import PendingReservationsEmptyState from './PendingReservationsEmptyState';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function PendingReservations() {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const track = useTrackPendingTab();
  const { count, loading, hasFetched, reservations, empty } = useSelector(
    (state) => state.DashboardSlice.pendingReservations
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPendingReservations(query));
    },
    [],
    { hasFetched }
  );

  const { allPermissions } = useSelector(
    (state) => state.AuthSlice.permissions
  );
  const urlRedirect = `${tokkoHost}/properties/reservations`;

  const reservationsText = `${count} ${Trans(
    translations,
    count === 1 ? 'ReservationToExpire' : 'ReservationsToExpire'
  )}`;

  const canSeeReservationList = allPermissions.includes(
    'can_see_reservation_list'
  );

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={canSeeReservationList && !empty ? urlRedirect : false}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.pendingReservations(element)}
      >
        {reservationsText}
      </PendingCard.Header>
      {empty ? (
        <PendingReservationsEmptyState />
      ) : (
        <PendingReservationContainer
          reservations={reservations}
          trackCallback={(element) => track.pendingReservations(element)}
        />
      )}
    </PendingCard>
  );
}

export default PendingReservations;
